import { axiosMarketplace } from "../../services/axios";

const getInstalledApplications = async ({queryKey}) => {

  const res = await axiosMarketplace.get("/installed-application", {params: queryKey?.[1]});
  return res.data;
};

export default getInstalledApplications;
